/**
 * Scene 렌더 준비 게이트 — buildUi 완료 전(특히 scene.restart 재진입 후 비동기
 * loadAndApply 동안) update/타이머가 destroy된 View를 갱신하는 race를 차단한다.
 * Phaser 의존 0 — GameScene이 라이프사이클 시점에 reset()/markReady()를 호출한다.
 *
 * scene.restart()는 동일 Scene 인스턴스를 재사용(create()만 재호출)하므로 클래스 필드
 * 초기값에 의존할 수 없다. create()에서 reset()을 명시 호출해야 이전 게임의 ready 상태가
 * 새 게임으로 누출되지 않는다.
 */
export class SceneReadiness {
  private ready = false;

  /** create() 진입 시 호출. scene.restart는 인스턴스를 재사용하므로 명시적 리셋이 필수. */
  reset(): void {
    this.ready = false;
  }

  /** buildUi() 완료 시 호출 — 이후 update/타이머의 View 갱신을 허용한다. */
  markReady(): void {
    this.ready = true;
  }

  /** update/타이머가 View(HUD 등)를 갱신해도 안전한지. */
  get canRefresh(): boolean {
    return this.ready;
  }
}
